import PropTypes from "prop-types";
import { idPropType } from "./id-prop-type";

export const momentPropType = PropTypes.shape({
  caption: PropTypes.string,
  content: PropTypes.string,
  coverPhotoId: idPropType,
  eventType: PropTypes.string,
  featured: PropTypes.bool,
  isFeatured: PropTypes.bool,
  isStaff: PropTypes.bool,
  numReviewsByUser: PropTypes.number,
  photoIds: PropTypes.arrayOf(idPropType),
  photos: PropTypes.arrayOf(PropTypes.object),
  products: PropTypes.arrayOf(PropTypes.string),
  rating: PropTypes.number,
  reviewerSnapshot: PropTypes.object,
  reviewId: idPropType,
  sizeWorn: PropTypes.string,
  staff: PropTypes.bool,
  status: PropTypes.string,
  styleName: PropTypes.string,
  uploadedAt: PropTypes.string, // date
  userId: idPropType,
});

export const reviewPropType = PropTypes.shape({
  id: idPropType,
  moment: PropTypes.object,
  user: PropTypes.object,
});

export const reviewsPropType = PropTypes.shape({
  averageRating: PropTypes.number,
  count: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.object),
  fitRating: PropTypes.number,
  item: PropTypes.object,
  loading: PropTypes.bool,
  page: PropTypes.number,
  perPage: PropTypes.number,
  sort: PropTypes.string,
  summary: PropTypes.object,
  userType: PropTypes.object,
});
